import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { AppGlobals } from '../app.globals';
import { DelayedDispatchService } from '../service/delayed-dispatch.service';
import { environment } from '../../environments/environment';
import { FGAData } from '../fga/models';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { VersionCheckService } from '../service/cache.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false // NOSONAR
})
export class MenuComponent implements OnInit, OnDestroy {

  items: MenuItem[];
  userName = '';
  rolesArray = [];
  fgaDetails: FGAData | null = null;
  private subscription: Subscription;
  CONST_ALLO = '/alloextracts'
  highlightHome = false;
  selected = new FormControl();
  currentIndex: any = 0;

  navlinks = {
    user: {
			person: { displayName: 'MAX JONES', icon: 'person' },
			logout: { displayName: 'LOGOUT', icon: 'logout' }
		},
		home: { home: {displayName: 'Home', url: 'home' }},
    planning: {
      alarms: { displayName: 'ALARMS', url: environment.ALARMS },
      allo: { displayName: 'ALLO', url: environment.ALLO },
      companyInfoChange: { displayName: 'company Info Change', url: 'mshell/maintenance/company-info-change' },
      costPlanning: { displayName: 'COST PLANNING', url: environment.COST_PLANNING },
      eboi: { displayName: 'EBOI', url: environment.EBOI },
      exports: { displayName: 'EXPORTS', url: environment.EXPORT },
      forecastAdmin: { displayName: 'Forecast Admin Dashboard (Import/Export dashboard)', url: environment.FORECAST_ADMIN_DASHBOARD },
      fto: { displayName: 'FTOs', url: 'opershell/operations/fto' },
      group1: { displayName: 'GROUP I', url: environment.GROUPI },
      dashboard: { displayName: 'Import/Export', url: 'opershell/operations/dashboard' },
      masterDock: { displayName: 'Master Dock', url: 'mshell/maintenance/master-dock' },
      regionTargets: { displayName: 'Region Targets', url: 'opershell/operations/region-targets' },
      scnc: { displayName: 'SCNC', url: 'opershell/operations/scnc' },
      taskManager: { displayName: 'TASK MANAGER', url: environment.TASK_MANAGER },
      tlmsSend: { displayName: 'TLMS Send', url: environment.TLMS_SEND },
      delayedDispatch: { displayName: 'Delayed Dispatch', url: environment.DD },
    },
    operations: {
      aet: { displayName: 'AET', url: environment.AET },
      companyInfo: { displayName: 'company Info', url: 'mshell/maintenance/company-info' },
      lpBilling: { displayName: 'LP Billing', url: 'bshell', fga: ['Billing Master', 'Logistics Cost Management', 'Cost Master', 'DRC', 'General Costs', 'Expedite Costs', 'Surcharges', 'LP Invoice', 'Billing Summary'] },
      trailerLoadDiagrams: { displayName: 'Trailer Load Diagrams', url: environment.TLD },
      uxmxroutes: { displayName: 'US MX Routes', url: 'opershell/operations/uxmxroutes' },
      wtResolution: { displayName: 'WT Resolution ', url: 'mshell/maintenance/window-times', fga: ['Window Times','TLMS Send'] }
    },
    reporting: {
      scheduleDashboard: {displayName: 'Schedule Dashboard',url: environment.SCHEDULE_DASHBOARD},
      reports: { displayName: 'Reports', url: environment.REPORTS },
    },
    maintenance: {
      notificationGroup: { displayName: 'Notification Group', url: 'admin/notification-group' },
      permissionManagement: { displayName: 'Permission Management', url: 'mshell/apm/permission-management/user-management' },
      returnsReload: { displayName: 'Returns Reload', url: 'mshell/maintenance/returns-reload', fga: ['Returns Reload'] },

    }
  };

  constructor(private readonly router: Router, private readonly globals: AppGlobals, private readonly service: DelayedDispatchService, private readonly versionCheckService: VersionCheckService) {

  }

  ngOnInit() { // NOSONAR
    this.items = [
      {
        label: 'Allo Extracts',
        icon: 'fa fa-folder-open',
        routerLink: [this.CONST_ALLO],
        routerLinkActiveOptions: { exact: true },
        id: 'ALLO',
        visible: true
      }
    ];
    this.subscription = this.service.getDetails().subscribe(details => {
      this.fgaDetails = details;
      console.info('[Header] FGA details received:', details);
      if (this.fgaDetails) {
        this.userName = localStorage.getItem('name');
        let roles = []
        this.rolesArray = [];
        roles = this.fgaDetails?.roles
        if (roles?.length) {
          roles.forEach(e => {
            this.rolesArray.push(e.displayName)
          })
        }
      }
    });
    this.selected.setValue(1);
    this.toggler('planning');
    this.versionCheckService.initVersionCheck();
  }

  navigateSelectedModule() {
    this.router.navigate([this.CONST_ALLO]);
  }

  validateUserRoles() {
    this.service.getValidateUserRoles().subscribe(
      (data: any) => {
        if (data == null || data == undefined) { // NOSONAR
          this.items[1].visible = true;
          this.items = [...this.items];
        }
      },
      (error: any) => {
        console.info(error.message);
      }
    );
  }

  logout() {
    window.location.replace(environment.LIOS_HOME_URL);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onTabClick(index: number) {
    localStorage.setItem('currentIndex', index.toString());
  }

  navigate(url: any) {
    const _url = environment.LIOS_HOME_URL + url;
    window.location.href = _url;
  }

  navigateExternalUrl(url: any) {
    window.location.href = url;
  }

  navigateExternalUrlNewWin(url: any) {
    window.open(url);
  }

  toggler(pageHeader: string): void {
    if (pageHeader.includes('home') || pageHeader == '' || pageHeader == '#') { // NOSONAR
      this.highlightHome = true;
    } else {
      this.highlightHome = false;
    }
  }

}